import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import { Tooltip } from '@heronhr/trivia-games';
import { ReactComponent as InfoIcon } from 'assets/images/home/infoIcon.svg';
import styles from './styles.module.scss';

const StandardAndProPlan = ({
  userPlan,
  activeUsers,
  openCustomerPortal,
  planPrices,
  handleButtonClick
}) => {
  const pricePerUnit = (planPrices && planPrices[userPlan]) || (userPlan === 'PRO' ? 2 : 1);
  const span = planPrices?.TERM || 'month';
  const roundOffNumber = (num) => Math.round(num * 100) / 100;

  const getPlanPrices = (price, term) => {
    if (term === 'month') {
      const yearlyPlanPrice = price * 12 * activeUsers;
      const yearlyPriceWithDiscount = yearlyPlanPrice * (1 - 0.2);
      const savings = yearlyPlanPrice - yearlyPriceWithDiscount;
      return {
        yearlyPlanPrice: roundOffNumber(yearlyPlanPrice),
        yearlyPriceWithDiscount: roundOffNumber(yearlyPriceWithDiscount),
        savings: roundOffNumber(savings),
        monthlyPricePerUnit: price
      };
    }
    const yearlyPlanPricePerUnit = price / 0.8;
    const monthlyPricePerUnit = yearlyPlanPricePerUnit / 12;
    const saving = activeUsers * yearlyPlanPricePerUnit - activeUsers * price;
    const yearlyPlanPrice = roundOffNumber(yearlyPlanPricePerUnit * activeUsers);
    return {
      yearlyPlanPrice,
      yearlyPlanPricePerUnit,
      yearlyPriceWithDiscount: roundOffNumber(yearlyPlanPrice - saving),
      monthlyPricePerUnit: roundOffNumber(monthlyPricePerUnit),
      savings: roundOffNumber(saving)
    };
  };
  const priceDetails = getPlanPrices(pricePerUnit, span);
  return (
    <>
      <div className={styles.anuallySection}>
        <div className={styles.savingsSection}>
          💰
          <div>
            {span === 'month' ? (
              <>
                Save <span>${priceDetails?.savings}</span> by paying annually!!
              </>
            ) : (
              <>
                You are saving <span>${priceDetails?.savings}</span> by paying annually!!
              </>
            )}
          </div>
        </div>
        <div className={styles.anuallyCard}>
          <div className={styles.yearlyDetails}>
            {userPlan}(Yearly)<div>${priceDetails?.monthlyPricePerUnit}/user/month</div>
          </div>
          <div className={styles.yearlyPlan}>
            <div className={styles.totalCost}>
              <span className={styles.crossed}>
                ${priceDetails?.yearlyPlanPrice}
                <span className={styles.year}>/year</span>
              </span>
              <span className={styles.offPercent}> 20% off</span>
            </div>
            <div className={styles.payingCost}>
              ${priceDetails?.yearlyPriceWithDiscount}
              <span className={styles.year}>/year</span>{' '}
              <span>
                <Tooltip
                  multiline
                  width={220}
                  label={`(${activeUsers} x $${priceDetails?.monthlyPricePerUnit} x 12) x 20% off = ${priceDetails?.yearlyPriceWithDiscount}`}
                  position='top'
                >
                  <InfoIcon className={styles.icon} />
                </Tooltip>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.finnalyText}>
        <div className={styles.exploreText}>
          Explore all plans, customizations, enterprise support & more features{' '}
          <button
            type='button'
            onClick={() => window.open('https://trytrivia.co/kb', '_blank')}
            className={styles.stripeButton}
          >
            here
          </button>
        </div>
        <div className={styles.payAnually}>
          {span === 'month' ? (
            <Button onClick={() => handleButtonClick(userPlan.toUpperCase())}>Pay annually</Button>
          ) : (
            <Button onClick={openCustomerPortal} className={styles.currentPlanBtn}>
              Current Plan
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

StandardAndProPlan.propTypes = {
  userPlan: PropTypes.string.isRequired,
  activeUsers: PropTypes.number.isRequired,
  openCustomerPortal: PropTypes.func.isRequired,
  planPrices: PropTypes.objectOf(
    PropTypes.shape({
      PRO: PropTypes.number.isRequired,
      STANDARD: PropTypes.number.isRequired,
      TERM: PropTypes.number.isRequired
    })
  ).isRequired,
  handleButtonClick: PropTypes.func.isRequired
};

export default StandardAndProPlan;
